import { Action } from "redux";

export const FINISH_GEOMETRY_EDIT = "FINISH_GEOMETRY_EDIT";

export interface FinishGeometryEditAction extends Action {}

export const finishGeometryEditAction = (): FinishGeometryEditAction => ({
    type: FINISH_GEOMETRY_EDIT,
});
